import { FC } from 'react';
import type { PhraseAuditItem } from '@/entities/phrases';
import { PhrasePlayButton } from '@/features/phrase-playback';
import { PhraseTextEditor } from './PhraseTextEditor';

type Props = {
  /** Реплика строки перечня */
  phrase: PhraseAuditItem;
};

/**
 * Ячейка реплики: её текст полем правки и прослушивание самой реплики.
 * Слушается ровно реплика — вычитка сверяет текст с тем отрезком записи, который ей принадлежит,
 * а остановка идёт по строке: соседние строки перечня бывают репликами одного диалога.
 * Кнопка из обхода с клавиатуры исключена: обход ведёт из текста реплики в текст следующей.
 */
export const PhraseTextCell: FC<Props> = ({ phrase }) => (
  <div className="flex w-full items-start gap-1">
    <PhraseTextEditor phrase={phrase} />
    <PhrasePlayButton
      conversationId={phrase.conversationId}
      startedAt={phrase.startedAt}
      finishedAt={phrase.finishedAt}
      playbackKey={String(phrase.id)}
      withLeadIn={false}
      isTabbable={false}
    />
  </div>
);
